<template>
  <div>
    <div class="mt-3 mb-5 underline">
      1 약관동의
      <mdb-icon  icon="chevron-right" class="mx-4" />
      <span class=" page-title">2 본인 인증</span>
      <mdb-icon  icon="chevron-right" class="mx-4" />
      3 회원 정보
      <mdb-icon  icon="chevron-right" class="mx-4" />
      4 가입 완료
    </div>

    <div>
      <div class="sub-title my-3">본인 확인 안내</div>
      <div>
        2014년 8월 7일 개인정보보호법이 개정 시행되어 모든 공공기관 및 민간사업자 등 사회 전 분야의 불필요한 주민번호 수집이 금지됨에 따라 회원 가입시 본인인증은 본인휴대폰 인증만 가능합니다.
      </div>
      <mdb-alert color="primary" class="my-4">
        <ul class="m-0">
          <li class="my-3">회원 가입은 중복가입, 개인정보 도용 및 허위 가입정보로 인한 피해를 사전에 방지하고자 금융감독위원회로부터 신용평가 전문기관으로 지정된 NICE 평가정보㈜ (http://www.niceinfo.co.kr)를 통해 본인인증 서비스를 실시하고 있습니다.</li>
          <li class="my-3">본인인증시 팝업화면에서 오류가 발생할 경우 NICE 평가정보㈜로 문의하여 주시기 바랍니다.</li>
        </ul>
      </mdb-alert>
      <mdb-row>
        <mdb-col md="1"></mdb-col>
        <mdb-col md="2" class="text-right">
          <img src="/images/phone.png">
        </mdb-col>
        <mdb-col class="ml-3">
          본인 휴대폰 정보로 인증 후 가입하실 수 있습니다.<br>
          본인 명의자가 아닐 경우 휴대폰 인증가입이 불가 할 수 있습니다.
          <div class="mt-3 mb-5 ml-5">
            <mdb-btn icon="check" color="primary" @click="onPhoneAuth" :disabled="!sEncData">휴대폰 인증</mdb-btn>
          </div>
        </mdb-col>
      </mdb-row>
    </div>
    <form name="form_chk" method="post" ref="form_chk">
    <!-- <form name="form_chk"  ref="form_chk"> -->
      <input type="hidden" name="m" value="checkplusSerivce">
      <input type="hidden" name="EncodeData" :value="sEncData">
    </form>
  </div>
</template>
<script>
import { mdbAlert } from 'mdbvue'
import { mapState, mapMutations, mapActions } from 'vuex';
import Auth from '@/models/Auth'
export default {
  name: 'JoinPhoneAuth',
  components: { mdbAlert },
  data: () => ({
    sEncData: ''
  }),
  computed: {
    org () {
      return this.$route.params.org
    }
  },
  methods: {
    async onPhoneAuth () {
      window.open('', 'popupChk', 'width=500, height=550, top=100, left=100, fullscreen=no, menubar=no, status=no, toolbar=no, titlebar=yes, location=no, scrollbar=no');

      // this.$refs.form_chk.action = `/${org}/join/authsuccess` // '/join/JoinAuthFail'
      // this.$refs.form_chk.target = 'popupChk'
      // this.$refs.form_chk.submit()

      this.$refs.form_chk.action = 'https://nice.checkplus.co.kr/CheckPlusSafeModel/checkplus.cb'
      this.$refs.form_chk.target = 'popupChk'
      this.$refs.form_chk.submit()
    }
  },
  watch: {
  },
  async created () {
    const msg = await Auth.nice(this.org)
    if (msg.result === 'ok') {
      this.sEncData = msg.sEncData
    } else {
      console.log('error ....', msg)
    }
  }
}
</script>
